<template>
  <div
    id="icon-pack-specs"
    style="--link-color: var(--theme-action-primary-dk); --link-hover-color: var(--theme-action-primary)"
  >
    <h3 class="sr-only">About {{ iconPack().label }}</h3>

    <div
      class="display-flex flex-row flex-wrap flex-items-center flex-content-center laptop:flex-content-between"
      style="gap: var(--spacing-xl)"
    >
      <dl class="icon-pack-metadata padding-0 margin-0 display-flex flex-row flex-wrap flex-items-center flex-content-between laptop:flex-content-start">
        <dt class="sr-only">Icon Canvas Size</dt>
        <!-- TODO: link to proper doc -->
        <dd
          class="icon-pack-metadata-item margin-bottom-0 text-nowrap"
          @mouseenter="handleToggle('Canvas')"
          @mouseleave="handleToggle('Canvas')"
        >
          <font-awesome-icon
            :icon="$v6.solid.faFrame"
            class="margin-right-2xs"
            fixed-width
          />
          <span class="size-sm"
            >{{ iconPack().sourceCanvasHeight }}px Canvas
            <!-- TODO V7: add link to docs when they are created -->
            <!-- <site-link :to="$docs('/')">Canvas</site-link> -->
          </span>
        </dd>

        <dt class="sr-only">Icon Grid Size</dt>
        <dd
          class="icon-pack-metadata-item margin-bottom-0 text-nowrap"
          @mouseenter="handleToggle('Grid')"
          @mouseleave="handleToggle('Grid')"
        >
          <font-awesome-icon
            :icon="$v6.solid.faExpand"
            class="margin-right-2xs"
            fixed-width
          />
          <span class="size-sm"
            >{{ iconPack().sourceGridHeight }}px Grid
            <!-- TODO V7: add link to docs when they are created -->
            <!-- <site-link
              :to="$docs('/')"
              @click.native="$posthog.capture('pack_landing:icon_grid_docs_link_click, { pack: iconPack().name }')"
              >Grid</site-link
            > -->
          </span>
        </dd>

        <template v-if="isReleased()">
          <dt class="sr-only">Total Icons</dt>
          <dd class="icon-pack-metadata-item margin-bottom-0 text-nowrap">
            <font-awesome-icon
              :icon="$v6.solid.faShapes"
              class="margin-right-2xs"
              fixed-width
            />
            <span class="size-sm"
              ><site-link
                :to="$search({ iconPacks: [iconPack().name] })"
                @click.native="$posthog.capture('pack_landing:all_pack_icons_link_click, { pack: iconPack().name }')"
                >{{ formattedTotalIconCount }} Icons</site-link
              ></span
            >
          </dd>

          <dt class="sr-only">Total Styles</dt>
          <dd class="icon-pack-metadata-item margin-bottom-0 text-nowrap">
            <font-awesome-icon
              :icon="$v6.solid.faPalette"
              class="margin-right-2xs"
              fixed-width
            />
            <span class="size-sm"
              ><site-link
                :to="$search({ iconPacks: [iconPack().name] })"
                @click.native="$posthog.capture('pack_landing:all_pack_styles_link_click, { pack: iconPack().name }')"
                >{{ styleCount }} {{ styleCountLabel }}</site-link
              ></span
            >
          </dd>

          <dt class="sr-only">Last Updated</dt>
          <dd class="icon-pack-metadata-item margin-bottom-0 text-nowrap">
            <font-awesome-icon
              :icon="$v6.solid.faArrowsRotate"
              class="margin-right-2xs"
              fixed-width
            />
            <span class="size-sm"
              >Updated in <site-link :to="{ name: 'changelog' }">{{ packLastUpdatedVersion }}</site-link></span
            >
          </dd>
        </template>
      </dl>

      <dl class="margin-0 padding-0 text-center laptop:text-right">
        <dt class="sr-only">Creator(s)</dt>
        <dd class="margin-bottom-0 text-nowrap">
          <font-awesome-icon
            :icon="$v6.solid.faSignature"
            class="margin-right-2xs"
            fixed-width
          />
          <span class="size-sm"
            >Designed by
            <a
              v-if="iconPack().url"
              :href="iconPack().url"
              target="_blank"
              @click.prevent="selectDesignerLink()"
              >{{ iconPack().designer }}
            </a>
            <span v-else>
              {{ iconPack().designer }}
            </span>
          </span>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
  import pluralize from 'pluralize'
  import UtilsMixin from 'app/views/UtilsMixin'

  export default {
    name: 'PackSpecs',

    mixins: [UtilsMixin],

    inject: ['iconPack', 'isReleased'],

    computed: {
      formattedTotalIconCount() {
        return this.formatNumber(this.totalIconCount, { precision: 0 })
      },

      packLastUpdatedVersion() {
        return this.iconPack().lastUpdatedVersion
      },

      styleCount() {
        return this.iconPack().familyStyles.length
      },

      styleCountLabel() {
        return pluralize('Style', this.styleCount)
      },

      totalIconCount() {
        if (!this.iconPack || !this.iconPack().familyStyles) return 0

        return this.iconPack().familyStyles.reduce((acc, familyStyle) => {
          return acc + this.familyStyleCount(familyStyle)
        }, 0)
      }
    },

    methods: {
      familyStyleCount({ family, style }) {
        return this.$releases.active.familyStyleCounts?.[family]?.[style]?.pro || 0
      },

      handleToggle(type) {
        this.$emit('toggleIconDesign', type)
      },

      selectDesignerLink() {
        this.$posthog.capture('pack_landing:pack_designer_link_click', { pack: this.iconPack().name })
        window.location.replace(this.iconPack().url)
      }
    }
  }
</script>
